import { render, staticRenderFns } from "./personal-page.vue?vue&type=template&id=834516bc&scoped=true&"
import script from "./personal-page.vue?vue&type=script&lang=js&"
export * from "./personal-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834516bc",
  null
  
)

export default component.exports